import BaseService from '../baseServices';
import REST from '../../configs/rest';
import { paramsFilter } from '../../utils/requests';

function putWorkOrders({ body, id }) {
  return BaseService.put(REST.WORK_ORDER_ID(id), body);
}

function postStationLog({ body }) {
  return BaseService.post(REST.WORK_ORDER_STATION_LOG, body);
}

function getWorkOrders(params) {
  return BaseService.get(REST.WORK_ORDER, {
    params: paramsFilter({ params }),
  });
}

function downloadWorkOrderItems(params) {
  return `${process.env.REACT_APP_REST_URL}${REST.WORK_ORDER_ITEM}?start=${params?.start}&end=${params?.end}`;
}

function downloadWorkOrderKPIDetailApproval(params) {
  // eslint-disable-next-line max-len
  return `${process.env.REACT_APP_REST_URL}${REST.WORK_ORDER_KPI_DETAIL_APPROVAL}?start=${params?.start}&end=${params?.end}`;
}

function getStationLog(params) {
  return BaseService.get(REST.WORK_ORDER_STATION_LOG, {
    params: paramsFilter({ params }),
  });
}

export default {
  getWorkOrders,
  downloadWorkOrderItems,
  downloadWorkOrderKPIDetailApproval,
  putWorkOrders,
  getStationLog,
  postStationLog,
};
